export default {
  referralsLoadingState(state) {
    return state.loading;
  },
  allReferralsListState(state) {
    return state.allReferrals || [];
  },
  referralDetailsBySlugState(state) {
    return state.referralDetailsBySlug || {};
  },
  referrerState(state) {
    return state.referrer || {};
  },
  referrerLoadingState(state) {
    return state.referrerLoading;
  },
  referralsErrorState(state) {
    return state.error;
  },
  referralDetailsErrorState(state) {
    return state.referralDetailsError;
  },
  referralsMetaState(state) {
    return state.meta || {};
  },
  referralInviteEmailListState(state) {
    return state.referralInvite.emails;
  },
  referralInviteState(state) {
    return state.referralInvite;
  },
  referralInviteEmailsCountState(state) {
    return state.referralInvite.emails.length;
  },
  referEmailsLoadingState(state) {
    return state.referEmailsLoading;
  },
  isSomeReferralNeedReview(state, getters) {
    return getters.allReferralsListState.filter(referral => referral.need_review).length > 0;
  }
};
